export default {
  state: {
    activeAudit: null,
  },

  getters: {
    //
  },

  mutations: {
    //
  },

  actions: {
    //
  },
};
